const TrolleybusIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
    >
      <path
        d="M0 4.99805C0 3.89348 0.895431 2.99805 2 2.99805H16C17.1046 2.99805 18 3.89348 18 4.99805V10.998H0V4.99805Z"
        fill="#17171C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 12.998H0V17.998C0 19.1026 0.89543 19.998 2 19.998H16C17.1046 19.998 18 19.1026 18 17.998V12.998ZM5 16.498C5 17.3265 4.32843 17.998 3.5 17.998C2.67157 17.998 2 17.3265 2 16.498C2 15.6696 2.67157 14.998 3.5 14.998C4.32843 14.998 5 15.6696 5 16.498ZM16 16.498C16 17.3265 15.3284 17.998 14.5 17.998C13.6716 17.998 13 17.3265 13 16.498C13 15.6696 13.6716 14.998 14.5 14.998C15.3284 14.998 16 15.6696 16 16.498Z"
        fill="#17171C"
      />
      <path
        d="M2 19.998H5V20.998C5 21.5503 4.55228 21.998 4 21.998H3C2.44772 21.998 2 21.5503 2 20.998V19.998Z"
        fill="#17171C"
      />
      <path
        d="M13 19.998H16V20.998C16 21.5503 15.5523 21.998 15 21.998H14C13.4477 21.998 13 21.5503 13 20.998V19.998Z"
        fill="#17171C"
      />
      <path
        d="M5 3.00195H7L7.58377 1.25064C7.78854 0.636335 7.3313 0.00195312 6.68377 0.00195312C6.27543 0.00195312 5.9129 0.263249 5.78377 0.650636L5 3.00195Z"
        fill="#17171C"
      />
      <path
        d="M11 3.00195H13L13.5838 1.25064C13.7885 0.636335 13.3313 0.00195312 12.6838 0.00195312C12.2754 0.00195312 11.9129 0.263249 11.7838 0.650636L11 3.00195Z"
        fill="#17171C"
      />
    </svg>
  )
}

export default TrolleybusIcon
